<template>
  <div class="p-3">
    <div class="row mt-3 mb-4">
      <div class="col col-sm col-12">
        <em class="fas fa-file-alt text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Documentos de Evaluación
        </span>
      </div>
    </div>
    <div class="mt-4">
      <custom-callout
        v-for="(item, index) in documents"
        :key="`doc-item-${index}`"
        border-color="gray"
        class="mb-2"
        :has-toggle="false"
      >
        <div class="row">
          <div class="col-2">
            <span class="mt-1 color-gray-6 d-block font-14">
              Tipo de Documento:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ item.documentTypeName | empty }}
            </span>
          </div>
          <div class="col-3">
            <span class="mt-1 color-gray-6 d-block font-14">
              Nombre del Archivo:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ item.filename | empty }}
            </span>
          </div>
          <div v-if="item.isEvaluationType" class="col-2">
            <span class="mt-1 color-gray-6 d-block font-14">
              Fecha de Evaluación:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ item.evaluationDate | date }}
            </span>
          </div>
          <div v-if="item.isEvaluationType" class="col-3">
            <span class="mt-1 color-gray-6 d-block font-14">
              Fecha redacción informe de evaluación:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ item.draftedDate | date }}
            </span>
          </div>
          <div v-if="item.isDiscussionType" class="col-2">
            <span class="mt-1 color-gray-6 d-block font-14">
              Fecha de Discusión:
            </span>
            <span class="font-16 color-black font-weight-bold">
              {{ item.discussionDate | date }}
            </span>
          </div>
          <div
            class="col-2 col-sm text-sm-right d-flex justify-content-end align-items-center pl-0 pr-4"
          >
            <custom-file-input
              v-if="
                (item.isReplaceable && !isReadOnly) ||
                  hasPermissionForReplaceDoc
              "
              ref="fileReplacementDocumentInputRef"
              accept=".pdf"
              accept-terms-modal-title="Certificación"
              accept-terms-text="Certifico que este documento que he subido al Sistema REMpro es copia fiel y exacta del original que pertenece a los récords de la Unidad Secretarial del Procedimiento de Querellas y Remedio Provisional (USPQRP) y que como proveedor de servicios seré custodio del mismo. Reconozco y acepto que este documento original me puede ser solicitado por la USPQRP en cualquier momento.(0423)"
              accept-terms-title="Acepto los términos y responsabilidades"
              accept-terms-validation-msg="Favor certifique el documento  que ha subido al sistema REMpro."
              allow-accept-terms
              class="file-replacement-input__extended"
              display-style="normal"
              label-position="right"
              name=" "
              :on-download="() => {}"
              @input="(file) => onReplacementFileHandler(file, item, index)"
            />
            <action-button
              class="btn-action-size"
              i="fas fa-file-download"
              variant="success"
              @click="() => onDownloadHandler(item)"
            />
          </div>
        </div>
        <div v-if="item.isEvaluationType" class="p-2 mt-3 ml-n2">
          <div class="bg-white rounded p-md-3 px-md-4">
            <div class="row">
              <div class="col-6">
                <span class="mt-1 color-gray-6 font-14">
                  Requiere evaluación a partir de la implementación de las
                  recomendaciones ofrecidas en este informe de evaluación:
                </span>
                <span class="font-16 color-black font-weight-bold ml-1">
                  {{ item.reevaluationRequired ? 'Sí' : 'No' }}
                </span>
              </div>
              <div class="col-5 col-sm col-12 mt-3 mt-md-0">
                <span class="mt-1 color-gray-6 font-14">
                  Tiempo para Reevaluación:
                </span>
                <span class="font-16 color-black font-weight-bold ml-1">
                  {{ reevaluationTime(item) | empty }}
                </span>
              </div>
              <div class="col-12 mt-3">
                <span class="mt-1 color-gray-6 d-block font-14">
                  ¿Con qué finalidad recomienda la reevaluación?:
                </span>
                <span class="font-16 color-black font-weight-bold">
                  {{ item.reevaluationPurpose | empty }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>

<script>
//component libs
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomFileInput from 'CustomFileInput';

//services
import {
  getEvaluationDocuments as _getEvaluationDocuments,
  replaceEvaluationDocument,
} from '@/services/uspqrp/contract.api.js';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';

//constants
import codeStudentReevaluationPeriods from '@/utils/constants/codeStudentReevaluationPeriods.js';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'ContractEvaluationDocuments',
  components: {
    CustomCallout,
    ActionButton,
    CustomFileInput,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    documents: [],
  }),
  computed: {
    reevaluationTime() {
      return (item) => {
        if (item.reevaluationRequired) {
          return `${item.reevaluationTime} ${
            item.reevaluationPeriodId == codeStudentReevaluationPeriods.year
              ? 'Año(s)'
              : 'Mes(es)'
          }`;
        }
        return null;
      };
    },
    hasPermissionForReplaceDoc() {
      return this.userHasPermissions(
        'rempro.providers.contract.replacementdocument'
      );
    },
  },
  async mounted() {
    await this.getEvaluationDocuments();
  },
  methods: {
    async onReplacementFileHandler(file, item, index) {
      if (this.hasPermissionForReplaceDoc && file && item.studentEvaluationId) {
        let formData = new FormData();
        formData.append('file', file);
        formData.append('documentTypeId', item.documentTypeId);

        await replaceEvaluationDocument(
          this.data.contractId,
          item.studentEvaluationId,
          formData
        ).then(() => {
          this.ShowToast(
            `Confirmación`,
            'El documento ha sido añadido exitosamente.',
            'success'
          );
        });
        await this.getEvaluationDocuments();
        this.$refs.fileReplacementDocumentInputRef[index].removeFile();
      }
    },
    async getEvaluationDocuments() {
      this.documents = (
        await _getEvaluationDocuments(
          this.data.contractId,
          this.data.disciplineTypeId,
          this.data.studentSieId
        )
      ).data;
    },
    onDownloadHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-action-size {
  width: 35px;
  height: 35px;
}

@import '~@/shared/scss/config/colors.scss';
.btn-action-size {
  width: 38px;
  height: 38px;
}

.file-replacement-input__extended {
  margin: unset !important;
}

.file-replacement-input__extended em {
  margin: 2px 2px 0 0 !important;
}

.btn-action-size i {
  margin-right: 0 !important;
}

.file-replacement-input__extended .file-input-container {
  min-width: 38px !important;
  min-height: 38px !important;
  border-color: map-get($colors, 'green');
}

.file-replacement-input__extended
  .file-input-container
  em.fas.fa-file-plus.pr-4.text-green:before {
  content: '\f0e2';
}

.file-replacement-input__extended .file-input-container span {
  display: none;
}
.file-replacement-input__extended div.button-container {
  display: none !important;
}
</style>
